import React, { useContext } from 'react';
import { Pressable } from 'react-native';
import { ListItem, withTheme } from '@rneui/themed';
import { isLocked, useIsEntitledQuery } from '@annunciate/query';
import { htmlToPlainText } from '../../utils';
import { View } from '../elements';
import { ListItemAvatar } from './ListItemAvatar';
import { Text as SkeletonText } from '../skeleton';
import { NavigationContext, useReactiveThemeProperty } from '../..';
export const UnthemedListItemBase = ({ item, children, listItemContainerStyle = {}, listItemContentStyle = {}, listItemSubtitleStyle = {}, childrenContainerStyle = {}, touchableStyle = {}, }) => {
    const { onNavigateToItem: onPress } = useContext(NavigationContext);
    const isEntitled = useIsEntitledQuery(item);
    const isLoading = !item;
    const uri = item?.cover?.src;
    const horizontalGutter = useReactiveThemeProperty('horizontalGutter');
    let isDownload = false;
    if (item?.__typename === 'Content') {
        isDownload = !!item?.isDownload;
    }
    return (React.createElement(ListItem, { containerStyle: [
            { flexDirection: 'column' },
            { paddingHorizontal: horizontalGutter },
            listItemContainerStyle,
        ] },
        React.createElement(Pressable, { style: touchableStyle, onPress: () => onPress && item && onPress(item) },
            React.createElement(ListItemAvatar, { source: uri ? { uri } : undefined, isLocked: (isLocked({ isEntitled, item }) && !isDownload) }),
            React.createElement(ListItem.Content, { style: listItemContentStyle }, isLoading ? (React.createElement(React.Fragment, null,
                React.createElement(SkeletonText, { size: "primary", lineWidth: "60%" }),
                React.createElement(SkeletonText, { size: "xsmall", lines: 2 }))) : (React.createElement(React.Fragment, null,
                React.createElement(ListItem.Title, null, item?.name),
                React.createElement(ListItem.Subtitle, { style: listItemSubtitleStyle }, htmlToPlainText(item?.description)))))),
        children && (React.createElement(View, { style: childrenContainerStyle }, children))));
};
export const ListItemBase = withTheme(UnthemedListItemBase, 'ListItemBase');
//# sourceMappingURL=ListItemBase.js.map